import { render, staticRenderFns } from "./evolucao.vue?vue&type=template&id=3e9bab62&scoped=true"
import script from "./evolucao.vue?vue&type=script&lang=js"
export * from "./evolucao.vue?vue&type=script&lang=js"
import style0 from "./evolucao.vue?vue&type=style&index=0&id=3e9bab62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9bab62",
  null
  
)

export default component.exports